import React from 'react';
import { MobileHeader } from '../mobile/MobileHeader';
import { OwnerBottomNav } from './OwnerBottomNav';
import type { OwnerNav } from '../../types/owner';
interface OwnerShellProps {
  nav: OwnerNav;
  title: string;
  subtitle?: string;
  back?: boolean;
  right?: React.ReactNode;
  footer?: React.ReactNode;
  tabs?: boolean;
  children: React.ReactNode;
  bodyClassName?: string;
}
export function OwnerShell({
  nav,
  title,
  subtitle,
  back = true,
  right,
  footer,
  tabs,
  children,
  bodyClassName = 'px-4 py-4'
}: OwnerShellProps) {
  return <div className="flex h-full flex-col bg-slate-50" data-id="element-1293" data-mp="27d6p69xwu9ff">
      <MobileHeader title={title} subtitle={subtitle} onBack={back ? nav.back : undefined} right={right} data-id="element-1294" data-mp="1tezz3fz7ddqb" />
      <div className={`no-scrollbar min-h-0 flex-1 overflow-y-auto ${bodyClassName}`} data-id="element-1295" data-mp="1yc8ljsrdw3xd">{children}</div>
      {footer && <div className="shrink-0 border-t border-border bg-white px-4 pb-4 pt-3" data-id="element-1296" data-mp="hy8pwtzkn0fx">{footer}</div>}
      {tabs && <OwnerBottomNav nav={nav} data-id="element-1297" data-mp="mzpnafiuk4rr" />}
    </div>;
}
export function OwnerCard({
  title,
  action,
  children,
  className = ''
}: {
  title?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  return <section className={`rounded-xl border border-border bg-white p-4 shadow-sm ${className}`} data-id="element-1298" data-mp="357x5ui77o2ie">
      {(title || action) && <div className="mb-3 flex items-center justify-between gap-2" data-id="element-1299" data-mp="3f379199cifxr">
          {title && <h2 className="text-sm font-semibold text-navy-900" data-id="element-1300" data-mp="3t38bgt59dvfc">{title}</h2>}
          {action}
        </div>}
      {children}
    </section>;
}
export function OwnerInfoList({
  rows
}: {
  rows: [string, React.ReactNode][];
}) {
  return <dl className="divide-y divide-slate-100" data-id="element-1301" data-mp="6mm0tuojfqvp">
      {rows.map(([k, v]) => <div key={k} className="flex items-start justify-between gap-3 py-2 text-[13px]" data-id="element-1302" data-mp="1okixd2ulxlt">
          <dt className="shrink-0 text-slate-500" data-id="element-1303" data-mp="fntw03vrcblk">{k}</dt>
          <dd className="text-right font-medium text-navy-900" data-id="element-1304" data-mp="fmip3v70mnq8">{v}</dd>
        </div>)}
    </dl>;
}
interface BtnProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'green' | 'outline' | 'danger' | 'ghost';
}
export function OwnerButton({
  variant = 'primary',
  className = '',
  children,
  ...rest
}: BtnProps) {
  const v = {
    primary: 'bg-navy-800 text-white hover:bg-navy-900',
    green: 'bg-bdgreen-600 text-white hover:bg-bdgreen-700',
    outline: 'border border-navy-200 bg-white text-navy-800 hover:bg-navy-50',
    danger: 'border border-red-200 bg-red-50 text-red-700 hover:bg-red-100',
    ghost: 'text-navy-700 hover:bg-navy-50'
  }[variant];
  return <button {...rest} className={`flex h-12 w-full items-center justify-center gap-2 rounded-xl px-4 text-[15px] font-semibold transition active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-50 ${v} ${className}`} data-id="element-1305" data-mp="16hlurxkta4ex">
      {children}
    </button>;
}